import { Content as RadixTooltipContent } from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { theme } from '../ui/theme';

export const Content = styled(RadixTooltipContent)`
    background-color: white;
    border: 1px solid ${theme.colors.foreground.subtle};
    box-shadow: ${theme.shadows.medium};
    border-radius: ${theme.radii[4]};
    padding: ${`${theme.space[4]} ${theme.space[8]}`};
    max-width: 300px;
    white-space: pre-wrap;
    z-index: ${theme.zIndex.interactive};
`;
